import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {BaseComponent} from '../base.component';
import * as SharedModels from '@shared-models/index';
import {Router} from '@angular/router';
import {AppConfigurationService} from '@ui-app/services/app-configuration.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {NavigationItemNames} from '@shared-models/common.enums';
import {MatMenuTrigger} from '@angular/material/menu';
import {CountryEnum} from '@shared-models/common.models';

@Component({
    selector: 'ui-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.less']
})
export class HeaderComponent extends BaseComponent implements OnChanges {

    constructor(
        public router: Router,
        private appConfigurationService: AppConfigurationService,
    ) {
        super();
    }

    @ViewChild('menuTrigger', {static: true}) menuTriggerChild: MatMenuTrigger;

    @Input() user: SharedModels.CM.IUserData;
    @Input() userPhotoFile: Blob;
    @Input() shouldShowUserProfile = false;
    @Input() shouldShowHeaderMenu = false;
    @Input() shouldShowHeader = false;
    @Input() navigationItems: SharedModels.CM.NavigationItem[] = [];
    @Input() IsEmployeeSearchAccessible: boolean = false;

    logoNavigateLink: SharedModels.CM.LogoNavigation = null;

    protected readonly window = window;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.user && this.user !== null && this.navigationItems != null) {
            this.logoNavigateLink = this.setLogoRedirection();
        }
    }

    setLogoRedirection(): SharedModels.CM.LogoNavigation {
        const employeeRoles = [
            SharedModels.CE.UserRoleEnum.EmployeeUSI,
            SharedModels.CE.UserRoleEnum.Employee,
            SharedModels.CE.UserRoleEnum.FTE,
            SharedModels.CE.UserRoleEnum.CLE,
            SharedModels.CE.UserRoleEnum.EchoPartner,
            SharedModels.CE.UserRoleEnum.CTH,
        ];
        const userRoleIds = this.user.userRoleIds?.length ? this.user.userRoleIds : [this.user.userRoleId];

        if (userRoleIds.some(id => id === SharedModels.CE.UserRoleEnum.PreHire)) {
            return null;
        }
        if (userRoleIds.some(id => employeeRoles.includes(id))) {
            return { url: `/profile/${this.user.userId}`, queryParams: {} };
        }
        return {
            url: this.navigationItems.find(item => item.itemName === NavigationItemNames.BadgeRequests).routerLink,
            queryParams: { categoryId: SharedModels.CE.BadgeRequestsCategoryId.All }
        };
    }

    isAvailableForCurrentUserRole(navigationItem: SharedModels.CM.NavigationItem): boolean {
        const availableForRoles = navigationItem.availableForRoles;
        if (!this.user) {
            return false;
        }
        const isSeniorManagerAllowed = availableForRoles?.includes(SharedModels.CE.UserRoleEnum.SeniorManagerUSI)
            && this.user.isSeniorManagerAndAbove;
        const userRoleIds = this.user.userRoleIds?.length ? this.user.userRoleIds : [this.user.userRoleId];
        return !!availableForRoles?.some(roleId => userRoleIds.includes(roleId)) || isSeniorManagerAllowed;
    }

    closeNavigationItem(navigationItem: SharedModels.CM.NavigationItem): void {
        navigationItem.isOpened = false;
        this.menuTriggerChild.closeMenu();
    }

    isAvailableForCurrentConfiguration$(itemName: SharedModels.CM.NavigationItem['itemName']): Observable<boolean> {
        return this.appConfigurationService.isSettingEnabled$(SharedModels.CE.AppConfigurationSettings.IsIndividualMobileBadgeEnabled)
            .pipe(
                map((isIndividualMobileBadgeEnabled) => {
                    return itemName === SharedModels.CE.NavigationItemNames.IndividualRequests ?
                        isIndividualMobileBadgeEnabled :
                        true;
                })
            );
    }

    isEmployeeSearchAvailableForCurrentUser() { //As access is restricted to only one user, this method is hardcoded to return true for that user
        if (this.IsEmployeeSearchAccessible) {
            return true;
        } else return false;
    }
}
